import { t } from '../i18n.ts';
import { h } from '../ui/dom.ts';

/** The choice, kept on the device for every goal panel that folds (the cellars, the Furrows). */
const KEY = 'somnhold.goalFolded';

const stored = (): boolean => {
  try {
    return localStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
};

/**
 * A goal panel's corner button: folded, the panel keeps its title, its bar and the clocks that press, and the room
 * shows. While folded, a new order makes the panel blink once, so it isn't missed.
 */
export class GoalFold {
  readonly el: HTMLButtonElement;
  private said = '';

  constructor(
    private goal: HTMLElement,
    test: string,
  ) {
    this.el = h('button.ex-fold', { type: 'button', 'data-test': test, onclick: () => this.set(!this.folded, true) }) as HTMLButtonElement;
    this.set(stored(), false);
  }

  get folded(): boolean {
    return this.goal.classList.contains('folded');
  }

  private set(on: boolean, keep: boolean): void {
    this.goal.classList.toggle('folded', on);
    this.el.textContent = on ? '+' : '–';
    const label = t(on ? 'goal.unfold' : 'goal.fold');
    this.el.setAttribute('aria-label', label);
    this.el.title = label;
    this.el.setAttribute('aria-expanded', String(!on));
    if (!keep) return;
    try {
      localStorage.setItem(KEY, on ? '1' : '0');
    } catch {
      /* fine */
    }
  }

  /** The order shown now: a new one while folded blinks the panel. */
  say(text: string): void {
    if (text === this.said) return;
    const first = this.said === '';
    this.said = text;
    if (first || !this.folded) return;
    this.goal.classList.remove('blink');
    void this.goal.offsetWidth;
    this.goal.classList.add('blink');
  }
}
